"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tableTreeGenerate;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _lodash = require("lodash");
var _table = _interopRequireDefault(require("./table"));
var _dataApi = _interopRequireDefault(require("./dataApi"));
var _paramsConvertTable = _interopRequireDefault(require("./paramsConvertTable"));
var _common = require("../utils/common");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultTableExtendInfo = {
  deleteType: 1,
  // 1 物理删除、2 逻辑删除、3 保留数据
  deleteField: '',
  // 标记删的字段
  deleteValue: '',
  // 标记删的值
  copyType: 1 // 作为关联数据时的复制行为：1 引用、2 复制
};

/**
 * 根据外部入参数，生成一颗table树
 * @param {*} mainTableKey
 * @param {*} forkTableKeyList
 * @param {*} relation
 * @param {*} tableExtendInfoList
 */
function tableTreeGenerate(_x, _x2, _x3, _x4) {
  return _tableTreeGenerate.apply(this, arguments);
}
/**
 * 通过table树的一层节点，生成子节点层（逐层的方式递归生成）
 * @param {*} tablesByLevel table树的一层table集
 * @param {*} tableList 全量table集：用于筛选table并标记
 * @param {*} relation 表关系集：用于读取关系
 */
function _tableTreeGenerate() {
  _tableTreeGenerate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, relation, tableExtendInfoList, dataStore) {
    var mainTableKey, forkTableKeyList, tableInitInfo, tableParams, allTableKeys, tableList, allPromise, mainTable;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mainTableKey = _ref.mainTableKey, forkTableKeyList = _ref.forkTableKeyList, tableInitInfo = _ref.tableInitInfo, tableParams = _ref.tableParams;
          _context.prev = 1;
          allTableKeys = [mainTableKey].concat(forkTableKeyList); // 初始化每个table实体
          tableList = [];
          allPromise = [];
          allTableKeys.forEach(function (tableKey) {
            var promise;
            if (dataStore.dataApiCache[tableKey]) {
              promise = Promise.resolve(dataStore.dataApiCache[tableKey]);
            } else {
              promise = tableInitInfo.getCollection(_objectSpread(_objectSpread({}, tableInitInfo.option), {}, {
                collectionId: tableKey
              }));
            }
            promise.then(function (requester) {
              // eslint-disable-next-line
              dataStore.dataApiCache[tableKey] = requester;
              var schemaList = requester.getEntitySchema();
              var table = new _table.default({
                tableKey: tableKey,
                isMain: tableKey === mainTableKey,
                schemaList: (0, _lodash.cloneDeep)(schemaList)
              });
              table.dataApi = new _dataApi.default(table, requester);
              var findTable = tableExtendInfoList.find(function (item) {
                return item.tableKey === tableKey;
              });
              if (findTable) {
                table.tableExtendInfo = _objectSpread(_objectSpread({}, (0, _lodash.cloneDeep)(defaultTableExtendInfo)), (0, _lodash.cloneDeep)(findTable));
              } else {
                table.tableExtendInfo = (0, _lodash.cloneDeep)(defaultTableExtendInfo);
              }
              tableList.push(table);
            });
            allPromise.push(promise);
          });
          _context.next = 8;
          return (0, _common.allSettled)(allPromise);
        case 8:
          if (tableParams) {
            (0, _paramsConvertTable.default)(tableList, tableParams);
          }

          // 主表table的实例
          mainTable = tableList.find(function (item) {
            return item.isMain;
          });
          mainTable.nodeLevel = 0;
          // 从主表开始，按树的一层层递归顺序生成table树
          // 当前方案，一个table表只允许table树中生成一个节点！！！
          mainTable.treeRef = true;
          tableTreeLayerGenerate([mainTable], tableList, relation);
          return _context.abrupt("return", {
            tableTree: mainTable,
            rawTableList: tableList
          });
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](1);
          throw Error("tableTreeGenerate failed ".concat(JSON.stringify(_context.t0)));
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 16]]);
  }));
  return _tableTreeGenerate.apply(this, arguments);
}
var tableTreeLayerGenerate = function tableTreeLayerGenerate(tablesByLevel, tableList, relationObj) {
  var nextTablesByLevel = [];
  // 对当前这一层的table集，从左到右的生成子节点
  tablesByLevel.forEach(function (curTable) {
    // 获取未被curTable树引用的table集
    var forkTableKeys = tableList.filter(function (item) {
      return item.tableKey !== curTable.tableKey && !item.treeRef;
    }).map(function (item) {
      return item.tableKey;
    });
    // 获取与table有关联的关联信息集
    var tableRelation = relationObj.getRelationList(curTable.tableKey, forkTableKeys, tableList);
    tableRelation.forEach(function (relation) {
      var forkTable = tableList.find(function (item) {
        return item.tableKey === relation.childTableKey && !item.treeRef;
      });
      if (forkTable) {
        curTable.forkTableList.push({
          relationObj: relation,
          forkTable: forkTable
        });
        // 当前方案，一个table表只允许table树中生成一个节点
        forkTable.treeRef = true;
        forkTable.nodeLevel = curTable.nodeLevel + 1;
        nextTablesByLevel.push(forkTable);
      }
    });
  });

  // 新生成的子节点层不为空，则递归调用
  if (nextTablesByLevel.length > 0) {
    tableTreeLayerGenerate(nextTablesByLevel, tableList, relationObj);
  }
};